"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.http1ResToMeta = exports.fetchFirstFactory = exports.makeDefaultTransport = exports.setDefaultTransportFactory = void 0;
var fetch_1 = require("./fetch");
var xhr_1 = require("./xhr");
var defaultTransportFactory = fetchFirstFactory();
function setDefaultTransportFactory(t) {
    defaultTransportFactory = t;
}
exports.setDefaultTransportFactory = setDefaultTransportFactory;
function makeDefaultTransport(options) {
    return defaultTransportFactory(options);
}
exports.makeDefaultTransport = makeDefaultTransport;
function fetchFirstFactory() {
    if (detectFetchSupport()) {
        return (0, fetch_1.FetchReadableStreamTransport)();
    }
    return (0, xhr_1.XhrTransport)();
}
exports.fetchFirstFactory = fetchFirstFactory;
function detectFetchSupport() {
    var res = typeof fetch === 'function' && typeof Response !== 'undefined' && Response.prototype.hasOwnProperty('arrayBuffer');
    return res;
}
function http1ResToMeta(str) {
    var res = {};
    var pairs = str.split('\r\n');
    for (var i = 0; i < pairs.length; i++) {
        var p = pairs[i];
        var index = p.indexOf(':');
        if (index > 0) {
            var key = p.substring(0, index).trim();
            var value = p.substring(index + 1).trim();
            res[key] = value;
        }
    }
    return res;
}
exports.http1ResToMeta = http1ResToMeta;
